var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row lists-pagination" }, [
    _c("div", { staticClass: "col-sm-3 my-auto" }, [
      _c("span", { staticStyle: { "font-size": "12px" } }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.paginationInfo.pageStart) +
            "\n      -\n      " +
            _vm._s(_vm.paginationInfo.pageEnd) +
            "\n      \n      " +
            _vm._s(_vm.$t("Pagination.of.label")) +
            "\n      \n      "
        ),
        _c("b", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.getTotalLabel(_vm.paginationInfo.countTotal)) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-9 my-auto p-0 text-center" },
      [
        _c(
          "b-button-group",
          {
            staticClass: "float-md-right",
            staticStyle: { "margin-top": "7px" }
          },
          [
            _c("input-button", {
              attrs: {
                pointable: "",
                dissabled: !_vm.paginationInfo.canStepBack,
                variant: "plainText",
                smallerFont: "",
                inputPlaceholder: _vm.$t("Button.paginationPrevious")
              },
              on: { click: _vm.prevPage }
            }),
            _vm._v(" "),
            _c("input-button", {
              attrs: {
                pointable: "",
                dissabled: !_vm.paginationInfo.canStepForth,
                variant: "plainText",
                smallerFont: "",
                inputPlaceholder: _vm.$t("Button.paginationNext")
              },
              on: { click: _vm.nextPage }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "float-md-right" }, [_vm._t("filterSlot")], 2)
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-530dedfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-530dedfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/pagination/PaginationNavigation.vue
// module id = null
// module chunks = 